import { render, staticRenderFns } from "./RiskRatio.vue?vue&type=template&id=e5079c8e&scoped=true"
import script from "./RiskRatio.vue?vue&type=script&lang=js"
export * from "./RiskRatio.vue?vue&type=script&lang=js"
import style0 from "./RiskRatio.vue?vue&type=style&index=0&id=e5079c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5079c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VList,VListItem,VListItemContent,VListItemGroup,VListItemIcon,VListItemTitle,VSpacer})
